export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00245.eb15a2cd.png";